import {makeStyles} from '@mui/styles'
import {nth} from 'lodash-es'
import {FC, useContext} from 'react'
import {Link} from 'react-admin'
import {useNavigate} from 'react-router-dom'

import HistoryStackContext from '../contexts/HistoryStackContext'
import {ArrowLeftIcon} from './icons'

const BackNavigationLink: FC<BackNavigationLinkProps> = ({className, fallbackPath}) => {
  const styles = useStyles()
  const navigate = useNavigate()
  // The 2nd last history item is the previous location which we want to render as the
  // link's `href`. This allows the user to see the URL the browser will navigate to,
  // although we are going to call `goBack()` to pop from the history stack in case there
  // is a previous location. Otherwise `Link` will history-push the `fallbackPath`.
  const previousLocation = nth(useContext(HistoryStackContext), -2)
  const previousPath = previousLocation &&
    `${previousLocation.pathname}${previousLocation.hash}${previousLocation.search}`
  return (
    <Link
      className={`${styles.root} ${className ?? ''}`}
      onClick={e => {e.preventDefault(); navigate(-1)}}
      to={previousPath ?? fallbackPath}
      color="primary.main"
    >
      <ArrowLeftIcon />
    </Link>
  )
}

const useStyles = makeStyles(theme => ({
  root: {
    display: 'inline-box',
    paddingTop: theme.remSpacing(0.5),
    width: theme.typography.pxToRem(32),
  },
}))


interface BackNavigationLinkProps {
  className: string,
  fallbackPath: string
}

export default BackNavigationLink
